import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"


import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";


const vWB_PrdGrp_Fields: {[id:string]: ISearchProviderField } = {
  WB_PRDGRP_ID:                {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  PRODUCT_GROUP_ID:            {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Id', columnResourceName: 'colPGId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PRODUCT_GROUP_NAME:          {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  SUBTYPE_ID:                  {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Sub Type', columnResourceName: 'colSubTypeID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  TYPE_ID:                     {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Type', columnResourceName: 'colTypeID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  CANNIBALIZATION_TYPE_NAME:   {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Cannibalization Type Name', columnResourceName: 'colCannName', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
  WB_MODEL_CANNIBALIZATIONM_ID:{type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Cannibalization Type Id', columnResourceName: 'colCannWBId', alignment: HorizAlignment.Right, numberFormat: "#0.0"}, domainOptions: {}},
}

const vWB_PrdGrp_KeyFields =
    {id:    'WB_PRDGRP_ID',
     id_ui: 'PRODUCT_GROUP_ID',
     name:  'PRODUCT_GROUP_NAME'}


class ProductGroupSearchByCannibalizationTypeSearchProvider
    implements  ISearchProvider {

  aCannibalizationTypeId=0

  constructor(WB_MODEL_CANNIBALIZATIONM_ID: number){
    this.aCannibalizationTypeId = WB_MODEL_CANNIBALIZATIONM_ID
  }

  get keyFields() { return vWB_PrdGrp_KeyFields }

  get searchProviderFields(){
    return vWB_PrdGrp_Fields
  }

  search(searchOptions: ISearchRequestSubset): Promise<any[]> {
    return new Promise<any[]>((resolve, error) => {

      let findRequest = SearchUtils.makeSearchRequest(searchOptions,
          'vUI_ProductGroup_Search_ByCannibalizationType',
          this.searchProviderFields,
          [])

      findRequest.order = ['PRODUCT_GROUP_ID'];

      SearchUtils.intersectFilter(findRequest, "WB_MODEL_CANNIBALIZATIONM_ID",[this.aCannibalizationTypeId] )

      PASearch.findByRequest(findRequest)
          .then((res: any[]) => {
            resolve(res)
          })
          .catch((err) => {
            error(err)
          })
    })
  }

}

class ProductGroupSearchByCannibalizationTypeSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId="CannibalizationType"
  profileName= "Search by Cannibalization Type"
  renderOptions= {ui5ResourceId: "ProductGroupSearchByCannibalizationTypeProfile"}

  profileFilter=[
    {profileFilterName: 'Id', searchProviderFieldId: 'PRODUCT_GROUP_ID', renderOptions: {}},
    {profileFilterName: 'Name', searchProviderFieldId: 'PRODUCT_GROUP_NAME', renderOptions: {}}
  ]

  profileDisplayFields= [
    'PRODUCT_GROUP_ID', 'PRODUCT_GROUP_NAME', 'CANNIBALIZATION_TYPE_NAME', 'TYPE_ID', 'SUBTYPE_ID'
  ]

  profileTreeIdDefault= "default"
  profileTrees: ITree[] = []
  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault= ""   //string;
  profileSorts: ISearchSort[]= [] //ISearchSort[];

  constructor(WB_MODEL_CANNIBALIZATIONM_ID: number){
    this.aSearchProvider = new ProductGroupSearchByCannibalizationTypeSearchProvider(WB_MODEL_CANNIBALIZATIONM_ID)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class ProductGroupSearchByCannibalizationType
  implements  ISearch {

  constructor(WB_MODEL_CANNIBALIZATIONM_ID: number, options?: any){
    this.searchProfiles = [ new ProductGroupSearchByCannibalizationTypeSearchProfile(WB_MODEL_CANNIBALIZATIONM_ID) ]
  }

  searchName = "Select Product Group(s)"
  renderOptions = { ui5ResourceId: "ProductGroupSearchByCannibalizationType"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true


}
